// import { inject } from '@angular/core';
// import { HttpInterceptorFn } from '@angular/common/http';
// import { KeycloakService } from 'keycloak-angular';

// export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
//   const keycloak = inject(KeycloakService);
//   const token = keycloak.getKeycloakInstance().token;

//   const headers: Record<string, string> = {
//     'Content-Type': 'application/json',
//     Accept: 'application/json',
//   };


//   headers['Authorization'] = `Bearer ${token}`;


//   const cloned = req.clone({
//     setHeaders: headers,
//   });

//   return next(cloned);
// };

import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpHeaders } from '@angular/common/http'; // Import HttpHeaders
import { KeycloakService } from 'keycloak-angular';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const token = keycloak.getKeycloakInstance().token;

  let headers = req.headers;
  let skipContentType = headers.has('Skip-ContentType-Interceptor');

  // Remove the custom header if it exists
  if (skipContentType) {
    headers = headers.delete('Skip-ContentType-Interceptor');
  }

  // Set Authorization header
  headers = headers.set('Authorization', `Bearer ${token}`);
  // Set Accept header
  headers = headers.set('Accept', 'application/json');

  // Only set Content-Type if skipContentType is not true
  if (!skipContentType) {
    headers = headers.set('Content-Type', 'application/json');
  }

  const cloned = req.clone({
    headers: headers,
  });

  return next(cloned);
};
